module.exports = __webpack_public_path__ + "img/header-weddingRingsRingSets.a98032c.jpg";